var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTopWords(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.2416 4.9088C21 5.99208 21 7.5001 21 10.5161C21 13.5322 21 15.0402   20.2416 16.1235C19.9133 16.5924 19.4914 16.9951 19.0001 17.3084C18.0085 17.9408 16.6774 18.0207 14.25   18.0308V18.0323L13.0062 20.4065C12.5916 21.1978 11.4084 21.1978 10.9938 20.4065L9.75 18.0323V18.0308C7.32259 18.0207   5.99145 17.9408 4.99993 17.3084C4.50858 16.9951 4.0867 16.5924 3.75839 16.1235C3 15.0402 3 13.5322 3 10.5161C3 7.5001   3 5.99208 3.75839 4.9088C4.0867 4.43983 4.50858 4.03718 4.99993 3.72383C6.13494 3 7.71496 3 10.875 3H13.125C16.285 3   17.8651 3 19.0001 3.72383C19.4914 4.03718 19.9133 4.43983 20.2416 4.9088Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopWords);
export default __webpack_public_path__ + "static/media/TopWords.f065bde87835e4aa253a229122558b1a.svg";
export { ForwardRef as ReactComponent };